export const InitialValuesArchitectPassword = {
  oldPassword: "",
  newPassword: "",
  newPasswordConfirm: "",
};
